export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/x-close.773475df.svg","height":10,"width":10,"blurWidth":0,"blurHeight":0};